export const language: any = {
  LabelFavorites: "收藏夹",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe:
    "您还没有收藏任何菜肴。<br/>添加您喜欢的菜肴吧！",
  LabelDoYouWantUnSave: "您想取消收藏这个食谱吗？",
  save: "保存",
  unsave: "取消保存",
  OkFavorite: "是",
  CloseFavorite: "否",
};
